import { useState } from 'react'
import { useSession } from '../store/session'
import { Avatar } from './Avatar'
import { ProfileForm } from './ProfileForm'

interface Props {
  /** The small caption above the name. */
  eyebrow?: string
}

/**
 * Who you are here: avatar and nickname with an inline "Change" that swaps in the profile form.
 * Nobody is ever asked for a name first — a new player arrives with a generated one and this is
 * the one place that invites them to make it theirs.
 */
export function PlayingAs({ eyebrow = 'Playing as' }: Props) {
  const me = useSession((s) => s.me)
  const [editing, setEditing] = useState(false)
  if (!me) return null
  if (editing) {
    return <ProfileForm submitLabel="Save" autoFocus onDone={() => setEditing(false)} />
  }
  return (
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-3">
        <Avatar id={me.playerId} avatar={me.avatar} color={me.color} size="lg" />
        <div className="min-w-0">
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {eyebrow}
          </div>
          <div className="truncate text-lg font-black leading-tight">{me.nickname}</div>
          {me.nicknameAuto && (
            <div className="text-xs text-slate-500">We picked this name for you.</div>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={() => setEditing(true)}
        className="shrink-0 text-sm font-semibold text-sky-600 hover:underline"
      >
        Change
      </button>
    </div>
  )
}
